import List from 'src/storage/list';

class AdminManagersModel extends List {
  id = 'AdminManagersModel';
  defaultState = () => ({
    current: 'recent',
    total: 0,
    pageIndex: 0,
    sortBy: {
      sortKey: 'managerAddedDate',
      desc: true
    }
  });

  refreshOnInit = false;
  refreshOnSubscribe = false;
  sortBy = null;

  apiConfig = {
    refresh: {
      url: 'admin/manager/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'admin/manager/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'admin/manager/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    remove: {
      url: 'admin/manager/remove',
      validation: {},
      cancellable: true
    },
    removeClinic: {
      url: 'admin/clinic/remove',
      validation: {},
      cancellable: true
    },
    active: {
      url: 'admin/manager/active',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    }
  };

  _events = {
    'ws:modify_manager': 'onManager',
    profile: 'handleChangeProfileAndSwitchAccount'
  };

  onManager = (data) => {
    if (data.managerRemovedDate) this.removeItem(data.id);
    else {
      this._mergeItems([data], null, true);
      this.trigger();
    }
  };
  _matchMergeItem = (n, o) => {
    return {
      ...o,
      ...n
    };
  };

  listParams() {
    let req = {
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit,
      sortBy: this.state.sortBy,
      clinicId: this.state.clinicId
    };
    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    return req;
  }

  remove = (item, cb) => {
    let req = {
      id: item.id
    };
    this.api('remove', req, (err, data, success) => {
      cb && cb(err, data, success);
      !err && this.removeItem(item.id);
    });
  };

  removeClinic = (clinic, cb) => {
    let req = {
      id: clinic.id
    };
    this.api('removeClinic', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (!err) {
        this.refresh();
      }
    });
  };

  active = (item) => {
    let req = {
      id: item.id,
      managerActive: !item.managerActive
    };
    this.api('active', req, (err, data) => {
      !err && this._mergeItems([{ ...item, ...data }]);
    });
  };

  logAsManager = (item) => {
    this.emit('login_as_other_user', { id: item.id });
  };
}

const model = new AdminManagersModel();
export default model;
